<template>
  <div class="waitBox">
    <div class="waitTop">
      <div class="topLeft">
        <img src="../../assets/images/sy.png" alt="" />
      </div>
      <div class="topMiddle">{{ examName }}</div>
      <div class="topRight">
        <div class="rightTop">{{ time }}</div>
        <div class="rightBottom" v-html="formattedDate"></div>
      </div>
    </div>
    <div class="waitMiddleBox">
      <div class="waitMiddle">
        <div class="middleLeft">
          <div class="leftTop">进行中</div>
          <el-table
            class="table"
            :data="conductList"
            border
            style="width: 100%"
            align="center"
            ref="table"
          >
            <el-table-column prop="batch" label="考组" align="center">
            </el-table-column>
            <el-table-column prop="realName" label="姓名" align="center">
            </el-table-column>
            <el-table-column prop="jobNumber" label="工号" align="center">
            </el-table-column>
            <el-table-column
              prop="stationName"
              label="考站"
              align="center"
              style="font-size: 14px"
            >
            </el-table-column>
            <el-table-column
              prop="roomName"
              label="房间"
              align="center"
              style="font-size: 14px"
            >
            </el-table-column>
          </el-table>
        </div>
        <div class="middleRightOne" v-if="popUp == 1">
          <div class="rightTop">侯考中</div>
          <el-table
            :data="waitData"
            border
            style="width: 100%"
            align="center"
            ref="waitTable"
          >
            <el-table-column prop="batch" label="考组" align="center">
            </el-table-column>
            <el-table-column prop="realName" label="姓名" align="center">
            </el-table-column>
            <el-table-column prop="jobNumber" label="工号" align="center">
            </el-table-column>
          </el-table>
        </div>
        <div class="middleRightTwo" v-if="popUp == 2">
          <div class="rightTwoTop">当前叫号</div>
          <ul class="rightTwoBottom" ref="rightTwoBottom">
            <li v-for="(item, index) in callNumber" :key="index">
              {{ item.name }}---{{ item.roomName }}
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="waitBottom">
      <div class="bottomLeft">
        <img src="../../assets/images/leftIcon.png" alt="" />
      </div>
      <div class="waitMiddle">温馨提示！考试现场，保持安静！</div>
      <div class="waitRight">
        <img src="../../assets/images/rightIcon.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import io from "socket.io-client";
import { getScaleNum } from "@/utils/index.js";
import { getStationScreen, getIp } from "@/api/paper/paper";
export default {
  data() {
    return {
      time: "", // 当前时间
      formattedDate: "", // 当前日期
      examName: "",
      conductList: [],
      waitData: [],
      socket: null, // WebSocket 实例
      socketConnected: false, // WebSocket 连接状态
      reconnectAttempts: 0, // 重连次数
      maxReconnectAttempts: 1000, // 最大重连次数
      reconnectDelay: 3000, // 重连间隔时间（毫秒）
      scrollInterval: null,
      scrollIntervals: null,
      popUp: 1,
      callNumber: [],
      intervalId: null, // 存储定时器 ID，方便清除
      ipData: "",
    };
  },
  watch: {
    // 监听数据变化
    conductList: {
      handler() {
        this.$nextTick(() => {
          this.checkTableHeight("table");
        });
      },
      deep: true, // 深度监听
    },
    waitData: {
      handler() {
        this.$nextTick(() => {
          this.checkTableHeight("waitTable"); // waitData 表格
        });
      },
      deep: true, // 深度监听
    },
    callNumber: {
      handler() {
        this.$nextTick(() => {
          this.checkScrollHeight();
        });
      },
      deep: true, // 深度监听
      immediate: true, // 立即调用
    },
  },
  mounted() {
    // 初始化时间
    this.updateDateTime();
    // 每分钟更新一次时间
    setInterval(this.updateDateTime, 60000);
    // 初始检查表格高度
    this.checkTableHeight();
    this.$nextTick(() => {
      this.checkScrollHeight(); // 初始化检查滚动
    });
    this.startAutoRefresh();
  },
  created() {
    const codeAddress = this.$route.query.codeAddress;
    this.ipData = codeAddress;
    // this.ipData = window.location.hostname; // 获取当前页面的主机名
    // this.token = this.$route.query.token;
    let scaleNum = getScaleNum();
    document.documentElement.style.setProperty("--scale", scaleNum);
    window.addEventListener("resize", () => {
      let scaleNum = getScaleNum();
      document.documentElement.style.setProperty("--scale", scaleNum);
    });
    this.connectSocket();
    this.getStationScreenData();
    // this.getIpData();
  },
  beforeDestroy() {
    // 在组件销毁时清理 WebSocket 连接
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
    }
    // 清除滚动定时器
    this.stopAutoScroll();
    this.stopAutoScrolls(); // 清除定时器
    this.stopAutoRefresh();
  },
  methods: {
    // 获取当前时间和日期
    updateDateTime() {
      const now = new Date();

      // 获取时间部分
      const hours = String(now.getHours()).padStart(2, "0");
      const minutes = String(now.getMinutes()).padStart(2, "0");
      this.time = `${hours}:${minutes}`;

      // 获取日期部分
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, "0"); // 月份从0开始
      const date = String(now.getDate()).padStart(2, "0");

      // 获取星期部分
      const weekDays = [
        "星期日",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六",
      ];
      const weekDay = weekDays[now.getDay()];

      // 格式化日期部分
      this.formattedDate = `${year}年${month}月${date}日<span>${weekDay}</span>`;
    },
    async getStationScreenData() {
      this.waitData = [];
      this.conductList = [];
      const setList = {
        codeAddress: this.ipData,
      };
      const { data } = await getStationScreen(setList);
      this.waitData = data.waitList || [];
      this.conductList = data.examStationRoomNum || [];
      this.examName = data.examName;
    },
    // 启动定时刷新
    startAutoRefresh() {
      // 清除可能存在的旧定时器
      if (this.intervalId) {
        clearInterval(this.intervalId);
      }

      // 每隔 10 分钟调用一次接口
      this.intervalId = setInterval(() => {
        this.getStationScreenData();
      }, 10 * 60 * 1000); // 10 分钟 = 10 * 60 * 1000 毫秒

      // 立即调用一次，确保初始化
      this.getStationScreenData();
    },

    // 停止定时刷新
    stopAutoRefresh() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
    },
    async getIpData() {
      const { data } = await getIp();
      // "192.168.110.30"
      this.ipData = data;
      // this.ipData = "192.168.110.30";
      this.connectSocket();
    },
    // 初始化 WebSocket
    connectSocket() {
      console.log("尝试连接 WebSocket...");
      // 动态获取当前页面的协议和主机名
      const protocol = window.location.protocol === "https:" ? "wss" : "ws"; // 根据页面协议选择 ws 或 wss
      // const protocol = "ws";
      const hostname = window.location.hostname; // 获取当前页面的主机名
      const socketPort = 7777; // 强制使用 WebSocket 的端口 7777
      // 构建 WebSocket URL
      const socketUrl = `${protocol}://${hostname}:${socketPort}/`;
      console.log("socketUrl", socketUrl);
      // ws://192.168.3.200:7777
      // socketUrl
      this.socket = io(socketUrl, {
        query: {
          userId: this.ipData,
        },
        transports: ["websocket", "polling"],
        timeout: 5000,
      });

      // 监听连接事件
      this.socket.on("connect", () => {
        console.log("WebSocket 连接成功");
        this.socketConnected = true;
        this.reconnectAttempts = 0; // 重置重连次数
      });

      // 监听连接错误事件
      this.socket.on("connect_error", (error) => {
        console.error("WebSocket 连接失败", error);
        this.socketConnected = false;
        this.tryReconnect(); // 尝试重连
      });

      // 监听断开事件
      this.socket.on("disconnect", (reason) => {
        console.warn("WebSocket 已断开", reason);
        this.socketConnected = false;
        if (reason !== "io client disconnect") {
          this.tryReconnect(); // 尝试重连
        }
      });

      // // 考生在指定房间被叫号
      // this.socket.on("call_003", (data) => {
      //   // 遍历 data 数组，将数据添加到 callNumber
      //   data.forEach((entry) => {
      //     const newEntry = {
      //       name: entry.realName,
      //       roomName: "",
      //     };
      //     // 根据 roomId 找到对应的 roomName
      //     this.conductList.forEach((item) => {
      //       if (item.roomId === entry.roomId) {
      //         newEntry.roomName = item.roomName;
      //       }
      //     });
      //     // 将新数据添加到 callNumber
      //     this.callNumber.push(newEntry);
      //   });
      // });
      // 考生在指定房间被叫号
      this.socket.on("call_003", (data) => {
        // 遍历 data 数组，将数据添加到 callNumber
        data.forEach((entry) => {
          const newEntry = {
            name: entry.realName,
            roomName: "",
            roomId: entry.roomId, // 添加 roomId 用于去重
          };

          // 根据 roomId 找到对应的 roomName
          this.conductList.forEach((item) => {
            if (item.roomId === entry.roomId) {
              newEntry.roomName = item.roomName;
            }
          });

          // 检查是否已存在相同 roomId 的数据
          const exists = this.callNumber.some(
            (item) => item.roomId === entry.roomId
          );

          // 如果不存在，才添加到 callNumber
          if (!exists) {
            this.callNumber.push(newEntry);
          }
        });
        // 处理 popUp 状态
        if (this.popUpTimer) {
          // 如果已有计时器，清除计时器，延长弹窗展示时间
          clearTimeout(this.popUpTimer);
        } else {
          // 如果没有计时器，切换 popUp 到 2（展示状态）
          this.popUp = 2;
        }
        // 设置计时器，延迟 10 秒后将 popUp 设为 1
        this.popUpTimer = setTimeout(() => {
          this.popUp = 1;
          this.popUpTimer = null; // 清除计时器引用
        }, 30000); // 10 秒
        this.getStationScreenData();
      });

      // 考生在指定房间开始考试
      this.socket.on("start_004", (data) => {
        // this.conductList.forEach((item) => {
        //   if (item.roomId == data[0].roomId) {
        //     this.callNumber.roomName = item.roomName;
        //     item.batch = data[0].batch;
        //     item.realName = data[0].realName;
        //     item.jobNumber = data[0].jobNumber;
        //   }
        // });
        // this.waitData = this.waitData.filter(
        //   (item) => item.jobNumber !== data[0].jobNumber
        // );
        this.callNumber = this.callNumber.filter(
          (item) => item.roomId !== data[0].roomId
        );
        this.getStationScreenData();
      });
      // 考生在指定房间重叫
      this.socket.on("recall_005", (data) => {
        // 遍历 data 数组，将数据添加到 callNumber
        data.forEach((entry) => {
          const newEntry = {
            name: entry.realName,
            roomName: "",
          };
          // 根据 roomId 找到对应的 roomName
          this.conductList.forEach((item) => {
            if (item.roomId === entry.roomId) {
              newEntry.roomName = item.roomName;
            }
          });
          // 检查是否已存在相同 roomId 的数据
          const exists = this.callNumber.some(
            (item) => item.roomId === entry.roomId
          );
          // 如果不存在，才添加到 callNumber
          if (!exists) {
            this.callNumber.push({
              ...newEntry,
              roomId: entry.roomId, // 添加 roomId 用于去重
            });
          }
          this.getStationScreenData();
        });
        // 处理 popUp 状态
        if (this.popUpTimer) {
          // 如果已有计时器，清除计时器，延长弹窗展示时间
          clearTimeout(this.popUpTimer);
        } else {
          // 如果没有计时器，切换 popUp 到 2（展示状态）
          this.popUp = 2;
        }
        // 设置计时器，延迟 10 秒后将 popUp 设为 1
        this.popUpTimer = setTimeout(() => {
          this.popUp = 1;
          this.popUpTimer = null; // 清除计时器引用
        }, 30000); // 10 秒
      });
      // 考生在指定房间过号
      this.socket.on("pass_006", (data) => {
        this.callNumber = this.callNumber.filter(
          (item) => item.roomId !== data[0].roomId
        );
      });
      // 考生在指定房间完成考试
      this.socket.on("end_007", (data) => {
        this.getStationScreenData();
        // this.conductList.forEach((item) => {
        //   if (item.roomId === data[0].roomId) {
        //     item.realName = ""; // 将 realName 置空
        //     item.jobNumber = ""; // 将 jobNumber 置空
        //   }
        // });
      });
    },
    // 尝试重连 WebSocket
    tryReconnect() {
      // if (this.reconnectAttempts < this.maxReconnectAttempts) {
      //   this.reconnectAttempts++;
      //   console.log(`尝试第 ${this.reconnectAttempts} 次重连 WebSocket...`);
      setTimeout(() => {
        this.connectSocket();
      }, this.reconnectDelay);
      // }
      // else {
      //   console.error("已达到最大重连次数，停止重连");
      // }
    },
    checkTableHeight(refName) {
      const tableBody = this.$refs[refName]?.$el.querySelector(
        ".el-table__body-wrapper"
      );
      if (!tableBody) {
        console.warn(`没有找到表格 ${refName} 的内容区域`);
        return;
      }
      const scrollHeight = tableBody.scrollHeight;
      const clientHeight = tableBody.clientHeight;
      // 如果内容超出可视高度，启动滚动；否则清除滚动
      if (scrollHeight > clientHeight) {
        console.log(`${refName} 内容超出，启动滚动`);
        this.startAutoScroll(refName);
      } else {
        console.warn(`${refName} 内容不足，停止滚动`);
        this.stopAutoScroll(refName);
      }
    },
    startAutoScroll(refName) {
      const tableBody = this.$refs[refName]?.$el.querySelector(
        ".el-table__body-wrapper"
      );
      if (!tableBody) return;
      // 清除之前的滚动定时器（防止多次触发）
      this.stopAutoScroll(refName);
      this[`scrollInterval_${refName}`] = setInterval(() => {
        if (
          tableBody.scrollTop + tableBody.clientHeight >=
          tableBody.scrollHeight
        ) {
          // 滚动到底部后，回到顶部
          tableBody.scrollTop = 0;
        } else {
          // 每次滚动 2px
          tableBody.scrollTop += 2;
        }
      }, 50); // 每 50 毫秒滚动 2px
    },
    stopAutoScroll(refName) {
      if (this[`scrollInterval_${refName}`]) {
        clearInterval(this[`scrollInterval_${refName}`]);
        this[`scrollInterval_${refName}`] = null;
      }
    },
    checkScrollHeight() {
      const container = this.$refs.rightTwoBottom;
      if (!container) return;

      const scrollHeight = container.scrollHeight;
      const clientHeight = container.clientHeight;
      console.log("scrollHeight", scrollHeight, "clientHeight", clientHeight);

      if (scrollHeight > clientHeight) {
        console.log("内容超出，启动滚动");
        this.startAutoScrolls();
      } else {
        console.warn("内容不足，停止滚动");
        this.stopAutoScrolls();
      }
    },
    startAutoScrolls() {
      const container = this.$refs.rightTwoBottom;
      if (!container) return;

      // 清除之前的滚动定时器
      this.stopAutoScroll();

      this.scrollIntervals = setInterval(() => {
        if (
          container.scrollTop + container.clientHeight >=
          container.scrollHeight
        ) {
          // 滚动到底部后回到顶部
          container.scrollTop = 0;
        } else {
          // 每次滚动 2px
          container.scrollTop += 2;
        }
      }, 1000); // 每 50 毫秒滚动 2px
    },
    stopAutoScrolls() {
      if (this.scrollIntervals) {
        clearInterval(this.scrollIntervals);
        this.scrollIntervals = null;
      }
    },
  },
};
</script>


<style lang="scss">
:root {
  --scale: 1;
}
$scale: var(--scale, 1);
.waitBox {
  width: 100%;
  background: linear-gradient(180deg, #242f50 0%, #3680b3 50%, #242f50 100%);
  .waitTop {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: calc(#{$scale} * 120px);
    padding-left: calc(#{$scale} * 55px);
    padding-right: calc(#{$scale} * 65px);
    background: linear-gradient(180deg, #ffffff 0%, #afc3d0 100%);
    border-bottom-right-radius: calc(#{$scale} * 30px);
    border-bottom-left-radius: calc(#{$scale} * 30px);
    .topLeft {
      width: calc(#{$scale} * 302px);
      height: calc(#{$scale} * 72px);
      img {
        width: calc(#{$scale} * 302px);
        height: calc(#{$scale} * 72px);
      }
    }
    .topMiddle {
      width: calc(#{$scale} * 360px);
      height: calc(#{$scale} * 90px);
      line-height: calc(#{$scale} * 90px);
      background: linear-gradient(180deg, #3e88b2 0%, #0a456a 100%);
      border-radius: calc(#{$scale} * 45px);
      font-family: SourceHanSansCN, SourceHanSansCN;
      font-weight: bold;
      font-size: calc(#{$scale} * 48px);
      color: #ffffff;
      text-align: center;
    }
    .topRight {
      font-family: PingFangSC, PingFang SC;
      .rightTop {
        font-weight: 600;
        font-size: calc(#{$scale} * 44px);
        color: #0b476c;
        line-height: calc(#{$scale} * 48px);
        text-align: right;
      }
      .rightBottom {
        font-weight: 400;
        font-size: calc(#{$scale} * 28px);
        color: #0b476c;
        line-height: calc(#{$scale} * 28px);
        span {
          margin-left: calc(#{$scale} * 14px);
        }
      }
    }
  }
  .waitMiddleBox {
    padding: calc(#{$scale} * 22px) calc(#{$scale} * 20px);
    height: calc(#{$scale} * 870px);
    .waitMiddle {
      display: flex;
      justify-content: space-between;
      padding: calc(#{$scale} * 36px);
      background: linear-gradient(180deg, #ffffff 0%, #d2e4f0 100%);
      border-radius: calc(#{$scale} * 24px);
      .middleLeft {
        width: calc(#{$scale} * 1120px);
        height: calc(#{$scale} * 756px);
        background: linear-gradient(180deg, #ffffff 0%, #ebf3f9 100%);
        border-radius: calc(#{$scale} * 24px);
        border: calc(#{$scale} * 2px) solid #1b5385;
        overflow: hidden;
        .leftTop {
          height: calc(#{$scale} * 100px);
          line-height: calc(#{$scale} * 100px);
          text-align: center;
          background: linear-gradient(180deg, #0a456a 0%, #3e88b2 100%);
          border-top-right-radius: calc(#{$scale} * 24px);
          border-top-left-radius: calc(#{$scale} * 24px);
          border: 1px solid #1b5385;
          font-family: SourceHanSansCN, SourceHanSansCN;
          font-weight: bold;
          font-size: calc(#{$scale} * 48px);
          color: #ffffff;
        }
        .el-table {
          width: 100%;
          // overflow: hidden; /* 防止溢出内容影响其他布局 */
          overflow: visible !important; /* 避免阻止子元素滚动 */
        }
        .el-table__body-wrapper {
          width: 100%;
          height: calc(#{$scale} * 563px); /* 根据需要调整行高 */
          // overflow-y: auto !important; /* 添加滚动条 */
        }
        /* 调整行高 */
        .el-table .el-table__row {
          height: calc(#{$scale} * 92px); /* 根据需要调整行高 */
        }
        /* 调整中文字体大小 */
        .el-table .cell {
          padding: calc(#{$scale} * 10px) 0; /* 适当调整上下内边距 */
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: calc(#{$scale} * 40px);
          color: #031c55;
        }

        /* 如果你想要调整表头的高度和字体大小 */
        .el-table .el-table__header-wrapper .el-table__header {
          height: calc(#{$scale} * 92px); /* 根据需要调整表头高度 */
        }
        .el-table .el-table__header .cell {
          padding: 10px 0; /* 适当调整上下内边距 */
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: calc(#{$scale} * 40px);
          color: #031c55;
        }
        /* 强制表头第一列宽度 */
        .el-table__header-wrapper colgroup col:nth-child(1),
        .el-table__body-wrapper colgroup col:nth-child(1) {
          width: calc(#{$scale} * 140px); /* 覆盖动态宽度 */
        }
        /* 设置其他列的宽度为 243px */
        .el-table__header-wrapper colgroup col:nth-child(n + 2),
        .el-table__body-wrapper colgroup col:nth-child(n + 2) {
          width: calc(#{$scale} * 244px) !important;
        }
        /* 调整最后一列字体大小为 24px（仅影响表格内容，不影响表头） */
        .el-table__body-wrapper td:last-child .cell {
          font-size: calc(
            #{$scale} * 24px
          ) !important; /* 设置字体大小为 24px */
        }
      }
      .middleRightOne {
        width: calc(#{$scale} * 652px);
        height: calc(#{$scale} * 756px);
        background: linear-gradient(180deg, #ffffff 0%, #ebf3f9 100%), #f6fcff;
        border-radius: calc(#{$scale} * 24px);
        border: calc(#{$scale} * 2px) solid #1b5385;
        overflow: hidden;
        .rightTop {
          height: calc(#{$scale} * 100px);
          text-align: center;
          line-height: calc(#{$scale} * 100px);
          background: linear-gradient(180deg, #0a456a 0%, #3e88b2 100%);
          border-top-right-radius: calc(#{$scale} * 24px);
          border-top-left-radius: calc(#{$scale} * 24px);
          border: calc(#{$scale} * 1px) solid #1b5385;
          font-family: SourceHanSansCN, SourceHanSansCN;
          font-weight: bold;
          font-size: calc(#{$scale} * 48px);
          color: #ffffff;
        }
        .el-table {
          overflow-y: auto;
          width: 100%;
          overflow: hidden; /* 防止溢出内容影响其他布局 */
        }
        .el-table__body-wrapper {
          width: 100%;
          height: calc(#{$scale} * 563px); /* 根据需要调整行高 */
          // overflow-y: auto; /* 添加滚动条 */
        }
        /* 调整行高 */
        .el-table .el-table__row {
          height: calc(#{$scale} * 92px); /* 根据需要调整行高 */
        }
        /* 调整中文字体大小 */
        .el-table .cell {
          padding: calc(#{$scale} * 10px) 0; /* 适当调整上下内边距 */
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: calc(#{$scale} * 40px);
          color: #031c55;
        }

        /* 如果你想要调整表头的高度和字体大小 */
        .el-table .el-table__header-wrapper .el-table__header {
          height: calc(#{$scale} * 92px); /* 根据需要调整表头高度 */
        }
        .el-table .el-table__header .cell {
          padding: 10px 0; /* 适当调整上下内边距 */
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: calc(#{$scale} * 40px);
          color: #031c55;
        }
        /* 强制表头第一列宽度 */
        .el-table__header-wrapper colgroup col:nth-child(1),
        .el-table__body-wrapper colgroup col:nth-child(1) {
          width: calc(#{$scale} * 145px); /* 覆盖动态宽度 */
        }
        /* 设置其他列的宽度为 243px */
        .el-table__header-wrapper colgroup col:nth-child(n + 2),
        .el-table__body-wrapper colgroup col:nth-child(n + 2) {
          width: calc(#{$scale} * 252px) !important;
        }
      }
      .middleRightTwo {
        width: calc(#{$scale} * 652px);
        height: calc(#{$scale} * 756px);
        background: linear-gradient(180deg, #ffffff 0%, #ebf3f9 100%), #f6fcff;
        border-radius: calc(#{$scale} * 24px);
        border: calc(#{$scale} * 2px) solid #1b5385;
        overflow: hidden;
        .rightTwoTop {
          height: calc(#{$scale} * 192px);
          line-height: calc(#{$scale} * 192px);
          text-align: center;
          background: linear-gradient(180deg, #8dbbd7 0%, #d5eefa 100%),
            linear-gradient(180deg, #3e88b2 0%, #0a456a 100%);
          font-family: SourceHanSansCN, SourceHanSansCN;
          font-weight: bold;
          font-size: calc(#{$scale} * 56px);
          color: #ffffff;
        }
        // .rightTwoMiddle {
        //   height: 94px;
        //   line-height: calc(#{$scale} * 94px);
        //   text-align: center;
        //   background: linear-gradient(180deg, #3e88b2 0%, #296991 100%);
        //   font-family: PingFangSC, PingFang SC;
        //   font-weight: 600;
        //   font-size: calc(#{$scale} * 48px);
        //   color: #ffffff;
        // }
        // .rightTwoBottom {
        //   height: 468px;
        //   line-height: calc(#{$scale} * 468px);
        //   text-align: center;
        //   background: linear-gradient(180deg, #3e88b2 0%, #296991 100%);
        //   font-family: PingFangSC, PingFang SC;
        //   font-weight: 600;
        //   font-size: calc(#{$scale} * 72px);
        //   color: #031c55;
        // }
        .rightTwoBottom {
          height: 566px;
          overflow: hidden; /* 隐藏超出的内容 */
          position: relative;
          li {
            height: 63px;
            line-height: 63px;
            text-align: center;
            font-weight: 600;
            font-size: calc(#{$scale} * 30px);
            color: #031c55;
            background-color: #8dbbd7;
          }
          li:nth-child(2n) {
            background-color: #d5eefa;
          }
        }
      }
    }
  }
  .waitBottom {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 calc(#{$scale} * 20px);
    width: 100%;
    height: calc(#{$scale} * 90px);
    background: linear-gradient(180deg, #ffffff 0%, #afc3d0 100%);
    border-top-right-radius: calc(#{$scale} * 30px);
    border-top-left-radius: calc(#{$scale} * 30px);
    .bottomLeft {
      width: calc(#{$scale} * 90px);
      height: calc(#{$scale} * 90px);
      img {
        width: calc(#{$scale} * 90px);
        height: calc(#{$scale} * 90px);
      }
    }
    .waitMiddle {
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: calc(#{$scale} * 32px);
      color: #0b476c;
      text-align: left;
      font-style: normal;
    }
    .waitRight {
      width: calc(#{$scale} * 90px);
      height: calc(#{$scale} * 90px);
      img {
        width: calc(#{$scale} * 90px);
        height: calc(#{$scale} * 90px);
      }
    }
  }
}
</style>
